import { Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import { SpinWrapper } from '../../../../../../OnBoarding/Register/Education/style'
import CourseForm from '../ProjectForm'
import React, { useEffect, useState } from 'react'
import instituteRequest from '../../../../../../../utils/instituteRequest'

import { Form } from 'antd'
import { searchAPI, setResumeData } from '../../../../../../OnBoarding/actions'
import {
  AdjustIcon,
  FooterFlex,
  StyledDrawer,
} from '../../DrawerStyle'
import { SubHeading1 } from '../../EducationDetailStyle'
import {
  ButtonLocal,
  Text,
} from '../style'
import { useDispatch, useSelector } from 'react-redux'
import { searchConfig } from 'utils/config'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { getStudentDataById } from '../../../../../actions'
import UpdatePopup  from '../../../UpdatePopup'
import SuccessPopupModal from '../../../SuccessPopup'

const CourseTrainingDrawer = ({
  drawerStatus,
  setdrawerStatus,
  updateStudentData,
  studentFormData,
  pendingData,
  getPendingData,
  listOfStudentSkills,
  getListOfSkills,
  studentId,
}) => {
  const [form] = Form.useForm()
  const [course, setCourse] = useState([])
  const dispatch = new useDispatch()
  const [instituteCampusName, setInstituteCampusName] = useState('')
  const [organizationId, setOrganizationId] = useState('')
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)
  const [skillLoading, setSkillLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [listOfSkills, setListOfSkills] = useState([])
  const [updated, setUpdated] = useState(false)
  const [shown, setShown] = useState([])
  const [listOfAddedSkills, setListOfAddedSkills] = useState([])
  const [tpoConfig, setTpoConfig] = useState(null)
  const [frozenFieldsMap, setFrozenFieldsMap] = useState({})
  const [showUpdatePopup, setShowUpdatePopup] = useState(false)
  const [succesPopup, setSuccessPopup] = useState(false)
  const pendingCourses = pendingData?.resume?.courses?.length > 0


  const SkillsAPI = async (page, search) => {
    try {
      const results = await dispatch(
        searchAPI(searchConfig?.skills?.name, search, searchConfig?.skills)
      )
      let v = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      }
      let updatedSkills = results || []
      if (updatedSkills?.length === 0 && search) {
        setListOfAddedSkills([...listOfAddedSkills, v])
        setListOfSkills([...updatedSkills, v])
      }
      const isExactMatch = updatedSkills?.some(
        skill => skill?.name.toLowerCase() === search?.toLowerCase()
      )
      if (updatedSkills?.length > 0) {
        if (!isExactMatch && search?.length > 3) {
          setListOfAddedSkills([...listOfAddedSkills, v])
          setListOfSkills([...updatedSkills, v])
        } else {
          setListOfSkills(updatedSkills)
        }
      }
    } catch (error) {
      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSkillLoading(true)
        await SkillsAPI(0)
      } finally {
        setSkillLoading(false)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    const fetchTpoConfig = async () => {
      try {
        const instituteCampusId = studentFormData?.student?.instituteCampusId
        if (instituteCampusId) {
          const response = await instituteRequest.get(
            `/institutes/${instituteCampusId}/tpo-approval-config`
          )
          if (response?.data?.data) {
            setTpoConfig(response.data.data)
          }
        }
      } catch (error) {
        console.error('Error fetching TPO config:', error)
      }
    }
    fetchTpoConfig()
  }, [studentFormData?.student?.instituteCampusId])

  useEffect(() => {
    if (!tpoConfig || !tpoConfig.tpoApprovalConfig || !tpoConfig.tpoApprovalConfig.fields) {
      setFrozenFieldsMap({})
      return
    }

    const approvedCertifications = studentFormData?.resume?.certifications || []
    const frozen = {}
    const fields = tpoConfig.tpoApprovalConfig.fields

    approvedCertifications.forEach((cert) => {
      if (!cert.id) return

      const certId = cert.id
      frozen[certId] = {}

      const certFields = ['issuingOrganisation', 'name', 'issueMonth', 'issueYear', 'expiryMonth', 'expiryYear', 'credentialId', 'credentialUrl']

      certFields.forEach((field) => {
        const fullFieldName = `certifications.${field}`
        const fieldConfig = fields[fullFieldName]

        if (fieldConfig && fieldConfig.freezeAfterVerification) {
          const fieldValue = cert[field]
          const hasValue = fieldValue !== null && fieldValue !== undefined && fieldValue !== '' && 
                           (!Array.isArray(fieldValue) || fieldValue.length > 0)

          if (hasValue) {
            frozen[certId][field] = true
          }
        }
      })
    })

    setFrozenFieldsMap(frozen)
  }, [tpoConfig, studentFormData?.resume?.certifications])

  const AllCollegeList = useSelector(state => state?.resumeData?.AllCollegeList)

  useEffect(() => {
    try {
      let courseList = []
      
      const approvedCourses = studentFormData?.resume?.courses || []
      const pendingRequests = pendingData?.requests || []
      
      // Transform API pending data structure
      const coursePendingMap = new Map()
      pendingRequests.forEach(request => {
        if (request.fieldName === 'certifications' && request.itemId && request.isNewItem) {
          coursePendingMap.set(request.itemId, {
            _isNewItem: true,
            _requestId: request.id,
            _status: request.status,
            ...request.requestedData
          })
        }
        // Handle field updates with fieldName='courses.fieldName'
        else if (request.fieldName?.startsWith('courses.') && request.itemId) {
          if (!coursePendingMap.has(request.itemId)) {
            coursePendingMap.set(request.itemId, {})
          }
          const fieldName = request.fieldName.replace('courses.', '')
          coursePendingMap.get(request.itemId)[fieldName] = {
            value: request.requestedData,
            originalValue: request.originalData,
            status: request.status,
            _requestId: request.id
          }
        }
      })
      
      // Merge approved courses with pending changes
      const mergedCourses = approvedCourses.map(approvedCourse => {
        const pendingData = coursePendingMap.get(approvedCourse.id)
        
        if (pendingData) {
          if (pendingData._isNewItem) {
            return {
              ...approvedCourse,
              _requestId: pendingData._requestId,
              _status: pendingData._status,
              _isNew: true
            }
          }
          
          // Otherwise, merge field-level changes
          if (Object.keys(pendingData).length > 0) {
            const merged = { ...approvedCourse }
            
            Object.keys(pendingData).forEach(fieldName => {
              if (fieldName !== '_requestId' && fieldName !== '_status' && pendingData[fieldName].value !== undefined) {
                merged[fieldName] = pendingData[fieldName].value
              }
            })
            
            merged._hasPendingChanges = true
            merged._pendingFields = pendingData
            
            return merged
          }
        }
        
        return approvedCourse
      })
      
      // Get IDs of all approved courses
      const approvedCourseIds = new Set(approvedCourses.map(c => c.id))
      
      // Handle new pending courses (only items that don't exist in approved courses)
      const newPendingCourses = []
      
      coursePendingMap.forEach((data, itemId) => {
        if (data._isNewItem && !approvedCourseIds.has(itemId)) {
          newPendingCourses.push({
            ...data,
            id: itemId,
            _isNew: true
          })
        }
      })
      
      const processedNewItems = new Set()
      pendingRequests.forEach(request => {
        if (request.fieldName?.startsWith('courses.') && request.itemId && request.status === 'PENDING') {
          const itemId = request.itemId
          
          // Only add if this itemId is NOT in approved courses and we haven't processed it yet
          if (!approvedCourseIds.has(itemId) && !processedNewItems.has(itemId) && !coursePendingMap.has(itemId)) {
            processedNewItems.add(itemId)
            const newCourse = { id: itemId, _isNew: true, _pendingFields: {} }
            
            // Collect all fields for this new item
            pendingRequests.forEach(req => {
              if (req.itemId === itemId && req.fieldName?.startsWith('courses.')) {
                const fieldName = req.fieldName.replace('courses.', '')
                newCourse[fieldName] = req.requestedData
                newCourse._pendingFields[fieldName] = {
                  value: req.requestedData,
                  status: req.status,
                  _requestId: req.id
                }
              }
            })
            
            newPendingCourses.push(newCourse)
          }
        }
      })
      
      const allCourses = [...mergedCourses, ...newPendingCourses]
      
      // Clear all existing course form fields to prevent duplicates
      const currentFormValues = form.getFieldsValue()
      const courseFieldsToRemove = Object.keys(currentFormValues).filter(key => key.startsWith('course_'))
      courseFieldsToRemove.forEach(fieldName => {
        form.setFieldsValue({ [fieldName]: undefined })
      })
      
      allCourses.map((data, index) => {
      let formName = 'course_' + index
      const formattedDescription = Array.isArray(data?.description)
        ? data.description.map(item => `${item}`).join('\n')
        : data?.description
      form.setFieldsValue({
        [formName]: {
          id: data?.id,
          temp_id: data?.temp_id,
          organization: data?.organization,
          organizationId: data?.organizationId,
          title: data?.title,
          started_in: data?.started_in,
          ended_in: data?.ended_in,
          industry: data?.industry,
          description: formattedDescription,
          skill_set: data?.skill_set,
          certificate: data?.certificate,
          awards: data?.awards,
          isDelete: false,
        },
      })
      return courseList.push({
        component: CourseForm,
        formName: formName,
      })
    })
      setCourse(courseList)
    } catch (error) {
      console.error('Error in CourseTrainingDrawer useEffect:', error)
      setCourse([])
    }
  }, [studentFormData, pendingData])

  const courseHandler = (isAdd, isDelete, deleteForm) => {
    const experienceKeys = Object.keys(form.getFieldValue())

    let lastValue = 0
    for (let i = experienceKeys.length - 1; i >= 0; i--) {
      const key = experienceKeys[i]
      const intValue = parseInt(key.split('_')[1])
      if (!isNaN(intValue)) {
        lastValue = intValue
        break
      }
    }
    let arr = []
    let formName = 'course_' + `${lastValue + 1}`

    if (isAdd) {
      const tempId = `temp-${Math.random().toString(36).substr(2, 9)}-${Date.now()}`
      form.setFieldsValue({
        [formName]: {
          id: null,
          temp_id: tempId,
          organization: null,
          organizationId: null,
          title: null,
          started_in: null,
          ended_in: null,
          industry: null,
          description: '',
          skill_set: [],
          certificate: null,
          awards: [],
          isDelete: false,
        },
      })
      arr.push({ component: CourseForm, formName: formName })
      setIsUpdateButtonEnabled(false)
      return setCourse([...course, ...arr])
    }
    if (isDelete) {
      form.setFieldValue([[deleteForm], 'isDelete'], true)
      setIsUpdateButtonEnabled(false)
      let updatedList = course?.filter(data => data?.formName !== deleteForm)
      return setCourse(updatedList)
    }
  }
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  const submitHandler = async () => {
    if (submitLoading) {
      return
    }
    
    setSubmitLoading(true)
    
    try {
      let course = []
      const values = await form.getFieldValue()
      const errorList = []
      await form
        .validateFields()
        .then()
        .catch(err => {
          errorList.push(err?.errorFields)
        })
      if (!errorList?.length) {
      // Collect courses from form values with deduplication
      const courseMap = new Map()
      
      Object.entries(values).forEach(([name, obj]) => {
        if (
          name.includes('course') &&
          !name.includes('award') &&
          !obj?.isDelete
        ) {
          const key = obj?.id || obj?.temp_id
          if (key && !courseMap.has(key)) {
            courseMap.set(key, {
              ...obj,
              awards: [],
            })
          } else if (key) {
            console.warn(`Duplicate course detected with key: ${key}, skipping...`)
          }
        }
      })
      
      course = Array.from(courseMap.values())

      // Collect awards for each course based on form field names
      const formFieldNames = Object.keys(values).filter(name => name.includes('course') && !name.includes('award'))
      
      formFieldNames.forEach((courseName, index) => {
        const courseData = values[courseName]
        const courseKey = courseData?.id || courseData?.temp_id
        
        if (courseKey && courseMap.has(courseKey)) {
          // Find awards for this course
          Object.entries(values).forEach(([name, obj]) => {
            if (name.includes(courseName + 'award')) {
              const courseInArray = course.find(c => (c.id || c.temp_id) === courseKey)
              if (courseInArray && !courseInArray.awards.some(a => JSON.stringify(a) === JSON.stringify(obj))) {
                courseInArray.awards.push(obj)
              }
            }
          })
        }
      })
      course = course.map(proj => ({
        ...proj,
        skill_set: proj.skill_set
          ? proj.skill_set.map(skill => ({
              id: uuidRegex.test(skill.id) ? skill.id : '',
              name: skill.name,
            }))
          : [],
      }))
      
      const newLocalPendingCourses = new Map()
      const existingCourseIds = new Set((studentFormData?.resume?.courses || []).map(course => course.id))
      
      course.forEach((courseItem, index) => {
        if (!courseItem.id || !existingCourseIds.has(courseItem.id)) {
          const tempId = 'temp-' + Date.now() + Math.random()
          const pendingItem = {
            ...courseItem,
            id: tempId,
            _isNew: true,
            _pendingFields: {},
            _hasPendingChanges: true
          }

          Object.keys(courseItem).forEach(key => {
            if (key !== 'shown' && key !== 'isDelete' && key !== 'formName') {
              pendingItem._pendingFields[key] = {
                value: courseItem[key],
                originalValue: null,
                status: 'PENDING',
                _requestId: tempId + '-' + key
              }
            }
          })

          newLocalPendingCourses.set(tempId, pendingItem)
          courseItem.id = tempId 
        }
      })

      try {
        const existingData = localStorage.getItem('pendingCourses')
        const parsed = existingData ? JSON.parse(existingData) : {}
        const studentId = studentFormData?.id
        
        if (!parsed[studentId]) {
          parsed[studentId] = []
        }

        newLocalPendingCourses.forEach((item, id) => {
          if (!parsed[studentId].find(existing => existing.id === id)) {
            parsed[studentId].push(item)
          }
        })

        localStorage.setItem('pendingCourses', JSON.stringify(parsed))
      } catch (error) {
        console.error('CourseTraining - Error saving to localStorage:', error)
      }
      
      let payload = {
        refreshRanking: true,
        isDirectTPOUpdate: true,
        checkDeleteSection: ['courses'],
        admin: {
          ...studentFormData?.admin,
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: studentFormData?.student ? {
          ...studentFormData?.student,
          id: studentId,
          instituteCampusId: studentFormData?.student?.instituteCampusId || studentFormData?.admin?.institute_campus_id,
        } : {
          id: studentId,
          instituteCampusId: studentFormData?.admin?.institute_campus_id,
        },
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? {
              ...studentFormData?.currentCourse,
              marks: studentFormData?.currentCourse?.marks ?? 0,
            }
          : {},
        education: studentFormData?.education,
        // education: studentFormData?.education.map((educationItem) => ({
        //   ...educationItem,
        //   organizationId: organizationId, // Add the organizationId property
        // })),
        resume: {
          ...studentFormData?.resume,
          courses: course,
        },
      }
      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === '') {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.registraionNo === null) {
        delete payload?.studentPersonalProfile?.registraionNo
      }
      if (studentFormData?.education && Array.isArray(studentFormData.education)) {
        studentFormData.education.map((item, index) => {
          if (item?.skills === null) delete payload?.education[index]?.skills
          if (item?.degreeStreamMapId === null)
            delete payload?.education[index]?.degreeStreamMapId
        })
      }
      if (payload?.resume?.courses && Array.isArray(payload.resume.courses)) {
        payload.resume.courses.map((item, index) => {
          if (
            item?.certificate == null ||
            Object.keys(item?.certificate)?.length === 0
          ) {
            delete payload?.resume?.courses[index]?.certificate
          }

          delete payload?.resume?.courses[index]?.startMonth
          delete payload?.resume?.courses[index]?.startYear
          delete payload?.resume?.courses[index]?.endMonth
          delete payload?.resume?.courses[index]?.endYear
        })
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      const response = await updateStudentData(payload)
      await dispatch(setResumeData(payload))
      
      if (response?.success === true) {
        SuccessMessage('Certification saved successfully!')
        setdrawerStatus(false)
        setUpdated(true)
        // Refresh data after successful update
        if (getPendingData) {
          await getPendingData()
        }
      } else {
        ErrorMessage(response?.response?.data?.message)
      }
      
      setSubmitLoading(false)
    } else {
      const errorForms = []

      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })

      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
    } catch (error) {
      console.error('Error in submitHandler:', error)
      ErrorMessage('An error occurred while submitting. Please try again.')
      setSubmitLoading(false)
    }
  }

  const content = () => {
    return (
      <>
        <Form
          scrollToFirstError
          onFinish={submitHandler}
          id={'courseForm'}
          form={form}
          layout="vertical"
        >
          {!!course.length &&
            course.map((obj, index) => {
              const approvedCourses = studentFormData?.resume?.courses || []
              const pendingRequests = pendingData?.requests || []
              const newCourseRequests = pendingRequests.filter(request =>
  request.fieldName === 'certifications' &&
  request.isNewItem === true &&
  request.status === 'PENDING'
)
              
              const coursePendingMap = new Map()
              pendingRequests.forEach(request => {
                if (request.fieldName?.startsWith('courses.') && request.itemId) {
                  if (!coursePendingMap.has(request.itemId)) {
                    coursePendingMap.set(request.itemId, {})
                  }
                  const fieldName = request.fieldName.replace('courses.', '')
                  coursePendingMap.get(request.itemId)[fieldName] = {
                    value: request.requestedData,
                    originalValue: request.originalData,
                    status: request.status,
                    _requestId: request.id
                  }
                }
              })
              const newPendingCourses = []

newCourseRequests.forEach(request => {
  const newCourse = {
    ...request.requestedData,
    id: request.itemId,
    _isNew: true,
    _hasPendingChanges: true,
    _pendingFields: {}
  }

  Object.keys(request.requestedData || {}).forEach(fieldName => {
    newCourse._pendingFields[fieldName] = {
      value: request.requestedData[fieldName],
      originalValue: null,
      status: request.status,
      _requestId: request.id
    }
  })

  newPendingCourses.push(newCourse)
})
              
              const allCourses = [...approvedCourses, ...newPendingCourses]
              const currentCourse = allCourses[index]
              const courseId = currentCourse?.id
              const pendingFields = courseId ? coursePendingMap.get(courseId) || {} : {}
              const hasPendingChanges = currentCourse?._hasPendingChanges || false
              const frozenFields = courseId ? frozenFieldsMap[courseId] || {} : {}
              
              return (
                <obj.component
                  key={index + 'course'}
                  form={form}
                  onRemove={courseHandler}
                  formName={obj?.formName}
                  studentFormData={studentFormData}
                  listOfStudentSkills={listOfStudentSkills}
                  getListOfSkills={getListOfSkills}
                  AllCollegeList={AllCollegeList}
                  instituteCampusValue={instituteCampusName}
                  setInstituteCampusName={setInstituteCampusName}
                  setOrganizationId={setOrganizationId}
                  organizationId={organizationId}
                  setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                  skillLoading={skillLoading}
                  setSkillLoading={setSkillLoading}
                  listOfSkills={listOfSkills}
                  SkillsAPI={SkillsAPI}
                  shown={shown}
                  frozenFields={frozenFields}
                  pendingFields={currentCourse?._pendingFields || {}}
                  hasPendingChanges={currentCourse?._hasPendingChanges || false}
                  isNew={currentCourse?._isNew || false}
                />
              )
            })}
        </Form>
        <SubHeading1>Note:</SubHeading1>
        <SubHeading1>
          Please fill in all details in the section below to ensure exposure to
          maximum number of corporates
        </SubHeading1>
        <ButtonLocal onClick={() => courseHandler(true, false)}>
          <Control alignCenter gap="10px">
            <AdjustIcon>
              <AddIcon />
            </AdjustIcon>
            <Text>Add Certification</Text>
          </Control>
        </ButtonLocal>
        {studentFormData?.resume?.courses?.length > 0 && skillLoading && (
          <SpinWrapper center>
            <Spin />
          </SpinWrapper>
        )}
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary
          onClick={async () => {
            try {
              await form.validateFields()
               if(!pendingCourses) {                
                form.submit()
              }
              else {
                setShowUpdatePopup(true)
              }
            } catch (err) {
            }
          }}         
          text={'Update'}
          disabled={isUpdateButtonEnabled || submitLoading}
          loading={submitLoading}
        />
      </FooterFlex>
    )
  }
  return (
    <>
          <UpdatePopup
        form={'courseForm'}
        htmlType="submit"
        open={showUpdatePopup}
        loading={submitLoading}
        onCancel={() => setShowUpdatePopup(false)}
        onConfirm={() => {
          setShowUpdatePopup(false)
          setSuccessPopup(true)
          form.submit()  
        }}
      />
      <SuccessPopupModal
        open={succesPopup}
        onClose={() => setSuccessPopup(false)}
      />
    <StyledDrawer
      width="675px"
      title={'Certification'}
      placement="right"
      closable={true}
      onClose={() => setdrawerStatus(false)}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
    </>
  )
}

export default CourseTrainingDrawer
